// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-49ba3b96]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.refund_content[data-v-49ba3b96] {\n  background: #fff;\n  padding: 10px;\n}\n.success[data-v-49ba3b96] {\n  color: #599c56;\n}\n.fail[data-v-49ba3b96] {\n  color: #e81212;\n}", ""]);
// Exports
module.exports = exports;
